import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import Marker from './Marker';
import stationSVG from '../../../images/maps/svg_icons/station.svg';

export default class Place extends React.Component {
  render() {
    const { lat, lng } = this.props.place;
    const color = '#000';

    const size = 18;

    const $svg = $(stationSVG);
    $svg.find('.colorize').css({ fill: color });

    const icon = {
      html: $svg.prop('outerHTML'),
      size: [size, size],
      className: 'place-marker'
    };

    return (
      <Marker position={[lat, lng]} icon={icon} zIndexOffset={800} type="station">
        <i className="fa fa-home mr-1" />
        {this.props.place.location_name}
      </Marker>
    );
  }
}

Place.propTypes = {
  place: PropTypes.object.isRequired
};
